import { useState, useEffect } from 'react';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

import AppBar from './AppBar';
import Drawer from './Drawer';

import { theme } from '../../utils/theme';

import MessageDialog from '../../store/messages/MessageDialog';

const Container = styled.div`
  background-color: ${props => props.theme.colors.body};
  position: relative;
  width: 100%;
  height: 100vh;
  display: grid;
  grid-template-columns: 20rem calc(100% - 20rem);
  grid-template-rows: 7rem minmax(calc(100vh - 7rem), 1fr);
  overflow: hidden;

  transition: all .5s;

  ${props => !props.open && css/* closed */`
    grid-template-columns: 5.5rem calc(100% - 5.5rem);
  `}

  @media ${props => props.theme.breaks.down('md')} {
    grid-template-columns: 100%;
    ${props => !props.open && css/* closed */`
      grid-template-columns: 100%;
    `}
  
  }
`

const BackDrop = styled.div`
  position: ${props => props.open ? 'fixed' : 'none'};
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  z-index: 5;

  @media ${props => props.theme.breaks.up('md')} {
    display: none;
  }
`

const Main = styled.div`
  grid-column: 2;
  grid-row: 2;
  padding: 2rem;
  overflow-y: auto;

  @media ${props => props.theme.breaks.down('md')} {
    grid-column: 1;
    padding: .5rem .2rem;
  }
`

// Synchronous read so `open` is correct on the very first render —
// no post-mount correction, no flash.
const getIsDesktop = () => window.innerWidth >= theme.breakpoints.values.md;

const Layout = ({children}) => {
  const [open, setOpen] = useState(getIsDesktop)

  const toggleOpen = () => setOpen(x => !x)

  useEffect(() => {
    const handleResize = () => setOpen(getIsDesktop())

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <Container open={open}>
      <BackDrop open={open} onClick={toggleOpen} />
      <AppBar toggleOpen={toggleOpen}/>
      <Drawer open={open} toggleOpen={toggleOpen} />
      <Main>
        {children}
        <MessageDialog />
      </Main>
    </Container>
  )
}

export default Layout;